import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ResultsService } from 'src/app/shared/services/master/results/results.service';
import { Router } from '@angular/router';
//https://stackoverflow.com/questions/51124039/child-to-parent-value-access-using-viewchild


@Component({
  selector: 'app-nettestrslts',
  templateUrl: './nettestrslts.component.html',
  styleUrls: ['./nettestrslts.component.scss']
})
export class NettestrsltsComponent implements OnInit {
  rsltType: string = "nettest";
  boolMainHeader: boolean = true;

  title: string;
  staticScreen = false;
  RsltTypeSwitch = true;
  @Output() childTitleEvent = new EventEmitter();

  selectedSubResults: any;

  constructor(private resultsService: ResultsService, router: Router) {
    this.resultsService.NetTestOrMobInfo.subscribe(res => {
      if (res.RsltTypeSwitch === false)
        router.navigateByUrl('/dashboard/mobileinfo');//https://stackoverflow.com/questions/32896407/redirect-within-component-angular-2 - IMP
    });
  }

  ngOnInit() {
  }
  receiveSubRslts($event) {
    this.selectedSubResults = $event;
  }

  parentEvent(title) {
    this.title = title;
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

}
